/**
 * # Gravatar
 * This service allows the use of Gravatar avatars. It uses the user's email
 * address to generate the URL for gravatar. If the user does not have a gravatar
 * email the default gravatar will show. If a user has no email, a default user
 * icon will show.
 */
angular.module('coreModule').directive('gravatar', (md5) => {
  const baseUrl = '//www.gravatar.com/avatar/';
  return {
    template: require('../../views/gravatar.html').default,
    restrict: 'E',
    scope: true,
    link: function postLink(scope: any, element, attrs) {
      let url, size;
      if (attrs.size === 'large') {
        size = '128';
        scope.avatarClass = 'avatar-lg';
      } else if (attrs.size === 'xl-large') {
        size = '256';
        scope.avatarClass = 'avatar-xl';
      } else {
        size = '64';
        scope.avatarClass = 'avatar';
      }

      if (attrs.email) {
        url = baseUrl + md5(attrs.email) + '?size=' + size;
        scope.avatar = url;
      } else {
        scope.avatar = require('../../images/user.png');
      }
    },
  };
});
